import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformationCircleFillMini = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.5999 11.9999C21.5999 17.3018 17.3018 21.5999 11.9999 21.5999C6.69797 21.5999 2.3999 17.3018 2.3999 11.9999C2.3999 6.69797 6.69797 2.3999 11.9999 2.3999C17.3018 2.3999 21.5999 6.69797 21.5999 11.9999ZM13.1999 7.1999C13.1999 7.86264 12.6626 8.3999 11.9999 8.3999C11.3372 8.3999 10.7999 7.86264 10.7999 7.1999C10.7999 6.53716 11.3372 5.9999 11.9999 5.9999C12.6626 5.9999 13.1999 6.53716 13.1999 7.1999ZM10.7999 10.7999C10.3028 10.7999 9.8999 11.2028 9.8999 11.6999C9.8999 12.197 10.3028 12.5999 10.7999 12.5999H11.104C11.2959 12.5999 11.4385 12.7776 11.3968 12.965L10.8458 15.4443C10.5544 16.7558 11.5524 17.9999 12.8958 17.9999H13.1999C13.697 17.9999 14.0999 17.597 14.0999 17.0999C14.0999 16.6028 13.697 16.1999 13.1999 16.1999H12.8958C12.7039 16.1999 12.5614 16.0222 12.603 15.8348L13.154 13.3555C13.4454 12.044 12.4474 10.7999 11.104 10.7999H10.7999Z",
		fill: "currentcolor"
	})]
});
export default SvgInformationCircleFillMini;
